// Chinese source messages are stable keys; values are the English interface.
// Parameter values (prompts, names, paths, and secrets) are never translated.
export const english: Readonly<Record<string, string>> = {
  这个屏幕崩了: "This screen ran into an error",
  "出现了一个未知错误。": "An unknown error occurred.",
  重新加载: "Reload",
  "发现新版本 {p0}": "Version {p0} is available",
  "可以现在安装，更新完成后 App 会自动重启。":
    "Install now? The app will restart after the update.",
  更新: "Update",
  正在下载更新: "Downloading update",
  "保持 App 打开，下载完成后会安装并重启。":
    "Keep the app open. It will install and restart when the download finishes.",
  正在安装更新: "Installing update",
  "马上重启。": "Restarting shortly.",
  更新失败: "Update failed",
  配置加载失败: "Could not load configuration",
  重试: "Retry",
  "加载配置中…": "Loading configuration…",
  "访问令牌不正确。": "The access token is incorrect.",
  需要访问令牌: "Access token required",
  "这个服务端设置了 ": "This server has configured ",
  "。输入访问令牌以继续。": ". Enter the access token to continue.",
  访问令牌: "Access token",
  "验证中…": "Verifying…",
  进入: "Continue",
  松开即可添加参考图: "Drop to add reference images",
  等待参考图: "Waiting for reference images",
  "拖拽、粘贴或点击左侧按钮添加图片。":
    "Drag, paste, or use the button on the left to add images.",
  图片: "Images",
  "输出会显示在这里，任务也会同步进入任务页。":
    "Outputs will appear here. You can also find the job in Tasks.",
  参考图: "Reference images",
  "· 可拖拽或粘贴": "· Drag or paste",
  添加参考图: "Add references",
  "拖进这里，或直接粘贴剪贴板图片。":
    "Drop images here or paste from the clipboard.",
  目标: "Target",
  参考: "Reference",
  遮罩: "Mask",
  设为目标: "Set as target",
  "删除 {p0}": "Delete {p0}",
  编辑模式: "Edit mode",
  多图参考: "Multiple references",
  局部编辑: "Local edit",
  提示词: "Prompt",
  "描述如何编辑这些图片...": "Describe how to edit these images...",
  凭证: "Credentials",
  "（无可用凭证）": "(No credentials available)",
  尺寸: "Size",
  质量: "Quality",
  格式: "Format",
  数量: "Count",
  涂抹模式: "Mask mode",
  绘制: "Draw",
  擦除: "Erase",
  笔刷: "Brush",
  清除选区: "Clear selection",
  提交中: "Submitting",
  应用编辑: "Apply edit",
  "计划输出 {p0} 张": "Planned outputs: {p0}",
  "当前凭证只输出 1 张": "These credentials support one output at a time",
  "遮罩会精确作用在目标图上。":
    "The mask applies precisely to the target image.",
  "会额外发送一张选区标记图；用户上传图片顺序保持不变。":
    "An extra selection marker image will be sent. Your uploaded images keep their original order.",
  "请切换到多图参考，或换一个支持局部编辑的凭证。":
    "Switch to multiple references or use credentials that support local editing.",
  "最多上传 {p0} 张参考图。": "You can upload up to {p0} reference images.",
  已忽略非图片文件: "Non-image files were ignored",
  "跳过 {p0} 个不支持的文件。": "Skipped {p0} unsupported files.",
  没有可添加的图片: "No images to add",
  "请拖入、粘贴或选择图片文件。": "Drag, paste, or choose image files.",
  参考图已达上限: "Reference image limit reached",
  "最多上传 {p0} 张。": "You can upload up to {p0} images.",
  已按上限添加参考图: "Added references up to the limit",
  "已添加 {p0} 张参考图": "Reference images added: {p0}",
  "来自拖拽上传。": "Added by drag and drop.",
  "来自剪贴板。": "Added from the clipboard.",
  请输入编辑提示词: "Enter an editing prompt",
  参数无效: "Invalid parameters",
  当前凭证不支持局部编辑: "These credentials do not support local editing",
  "请切换到「多图参考」，或换一个支持局部编辑的凭证。":
    "Switch to Multiple references or use credentials that support local editing.",
  请先选择目标图: "Choose a target image first",
  "遮罩会作用在目标图上。": "The mask applies to the target image.",
  "遮罩导出失败，请重新涂抹一次。":
    "Could not export the mask. Please draw the selection again.",
  遮罩导出失败: "Mask export failed",
  "请重新涂抹一次。": "Please draw the selection again.",
  "请先涂抹要修改的区域。": "Mark the area you want to edit first.",
  还没有选区: "No selection yet",
  "请在目标图上涂抹要修改的区域。":
    "Draw on the target image to mark the area you want to edit.",
  正在提交任务: "Submitting job",
  "{p0} · {p1} 张图片 · {p2}": "{p0} · Images: {p1} · {p2}",
  "已开始编辑 {p0} 张": "Editing started · Outputs: {p0}",
  已开始编辑: "Editing started",
  "{p0} · {p1} · 完成后通知你":
    "{p0} · {p1} · You will be notified when it finishes",
  编辑完成: "Editing complete",
  编辑失败: "Editing failed",
  请输入提示词: "Enter a prompt",
  "已开始生成 {p0} 张": "Generation started · Outputs: {p0}",
  已开始生成: "Generation started",
  "旧工作台里会继续显示占位图，完成后可在任务里查看。":
    "The classic workspace shows placeholders while the job runs. View the results in Tasks when it finishes.",
  生成完成: "Generation complete",
  "图片已生成并保存。": "The image has been generated and saved.",
  生成失败: "Generation failed",
  输出预览: "Output preview",
  "生成结果会按候选顺序保留在这里。":
    "Generated results stay here in candidate order.",
  进行中: "In progress",
  本次输出: "Current outputs",
  张: "images",
  还没有输出: "No outputs yet",
  "右侧写提示词并提交，经典工作台会把本次结果展示在这里。":
    "Enter a prompt on the right and submit. The classic workspace will show the results here.",
  生成: "Generate",
  编辑: "Edit",
  "先在「设置 → 凭证」里添加一个 API Key，才能开始生成。":
    "Add an API key in Settings → Credentials before generating images.",
  "描述你想生成的图像...": "Describe the image you want to generate...",
  任务: "Tasks",
  全部: "All",
  已完成: "Completed",
  "失败/部分失败": "Failed / Partial failure",
  删除任务记录: "Delete job record",
  "只会删除历史记录，远端 Origin/Archive 不会被删除。":
    "Only the history record will be deleted. Remote Origin/Archive files will remain.",
  删除: "Delete",
  取消任务: "Cancel job",
  "队列中的任务会停止继续处理。": "The queued job will stop processing.",
  清理任务记录: "Clear job records",
  "将清理 {p0} 条已结束任务。远端 Origin/Archive 不会被删除。":
    "Clear {p0} finished job records. Remote Origin/Archive files will remain.",
  清理: "Clear",
  任务历史: "Job history",
  "正在读取任务...": "Loading tasks...",
  "{p0} / {p1} 条记录": "{p0} / {p1} records",
  任务过滤: "Filter tasks",
  没有任务: "No tasks",
  "生成或编辑图片后，记录会出现在这里。":
    "Records will appear here after you generate or edit images.",
  新建生成: "New generation",
  设置: "Settings",
  图像生成: "Image generation",
  "写提示词，生成候选并保存图片":
    "Write a prompt, generate candidates, and save images",
  图像编辑: "Image editing",
  "上传参考图、粘贴图片、局部涂抹并提交编辑":
    "Upload references, paste images, draw a mask, and submit an edit",
  "查看正在运行、已完成和失败的生成记录":
    "View running, completed, and failed generation records",
  "凭证、外观、任务与通知偏好":
    "Credentials, appearance, tasks, and notifications",
  经典工作台: "Classic workspace",
  经典导航: "Classic navigation",
  工作台: "Workspace",
  默认凭证: "Default credentials",
  切换到暗色主题: "Switch to dark theme",
  切换到亮色主题: "Switch to light theme",
  松开添加参考图: "Drop to add references",
  "支持拖拽图片，也支持直接粘贴剪贴板图片":
    "Drag images here or paste them from the clipboard",
  请上传并设定目标图: "Upload and choose a target image",
  "或拖入图片、粘贴剪贴板图片。":
    "Or drag an image here or paste from the clipboard.",
  选择图片: "Choose images",
  请上传至少一张参考图: "Upload at least one reference image",
  "已保留收到的图片；如果需要补齐，可以点「应用」重试。":
    "Received images have been kept. Click Apply to retry if any outputs are missing.",
  目标图选区里要变成什么: "What should appear in the selected area?",
  "描述目标图选区里要变成什么...":
    "Describe what should appear in the selected area...",
  "描述如何参考这些图片进行编辑...":
    "Describe how to use these references for the edit...",
  "提交中…": "Submitting…",
  再提交: "Submit again",
  应用: "Apply",
  局部编辑模式: "Local edit mode",
  我懂了: "Got it",
  "这个模式只重画图片的某一区域,其他参考图只为风格 / 人物 / 物体提供线索。":
    "This mode redraws a selected area. Other reference images provide visual cues for style, people, or objects.",
  目标图: "Target image",
  "在它上面涂遮罩。AI 只重画涂掉的部分,其他像素保持原样。每次只能有一个目标图。":
    "Draw a mask on this image. The AI redraws the masked area and leaves other pixels unchanged. Only one target can be selected at a time.",
  "为目标图提供风格 / 人物 / 物体的视觉线索。AI 不会改写这些图本身。":
    "Provide visual cues for the target's style, people, or objects. The AI does not modify the reference images themselves.",
  "切换回「多图参考」可以用同一组图按多张参考自由拼合。":
    "Switch back to Multiple references to combine the same images freely.",
  "选区绘制画布（{p0}）。拖动指针涂抹；键盘可用方向键移动，空格绘制，Delete 清除。":
    "Selection canvas ({p0}). Drag to draw; use arrow keys to move, Space to draw, and Delete to clear.",
  擦除模式: "Erase mode",
  绘制模式: "Draw mode",
  画笔: "Brush",
  橡皮: "Eraser",
  方形选区: "Rectangle selection",
  圆形选区: "Ellipse selection",
  清空选区: "Clear selection",
  撤回: "Undo",
  重做: "Redo",
  调整粗细: "Adjust size",
  粗细: "Size",
  选区工具粗细: "Selection tool size",
  适应窗口: "Fit to window",
  缩小: "Zoom out",
  放大: "Zoom in",
  平移: "Pan",
  打开输出抽屉: "Open outputs drawer",
  "生成中 · {p0} 张": "Generating · Outputs: {p0}",
  "输出 · {p0} 张": "Outputs · {p0} images",
  位置: "Location",
  关闭输出抽屉: "Close outputs drawer",
  "{p0}：{p1}{p2}": "{p0}: {p1}{p2}",
  "，已绘制遮罩": ", mask drawn",
  "把「{p0}」设为目标图": 'Set "{p0}" as target',
  "删除「{p0}」": 'Delete "{p0}"',
  参考图缩略图: "Reference image thumbnail",
  "查看参考图 {p0}: {p1}": "View reference {p0}: {p1}",
  "删除第 {p0} 张参考图": "Delete reference image {p0}",
  "把第 {p0} 张设为目标图": "Set image {p0} as target",
  "这张图没有可读取的文件路径或预览地址。":
    "This image has no readable file path or preview URL.",
  "读取图片失败：{p0} {p1}": "Could not read image: {p0} {p1}",
  "读取到的图片为空。": "The image is empty.",
  "读取到的文件不是图片。": "The file is not an image.",
  精确遮罩: "Precise mask",
  软选区参考: "Soft selection reference",
  不支持局部编辑: "Local editing is not supported",
  任务图片: "Job image",
  正在发送到编辑: "Sending to editor",
  已发送到编辑: "Sent to editor",
  "已作为新的参考图添加。": "Added as a new reference image.",
  发送到编辑失败: "Could not send to editor",
  "打开作品 {p0}:{p1}": "Open image {p0}:{p1}",
  远端不可用: "Remote image unavailable",
  发送到编辑: "Send to editor",
  生成中: "Generating",
  生成表单: "Generation form",
  关闭错误提示: "Dismiss error",
  "还没有凭证，": "No credentials yet. ",
  "去「设置 → 凭证」添加": "Add them in Settings → Credentials",
  生成提示词: "Generation prompt",
  "描述你想要生成的图像…": "Describe the image you want to generate…",
  "生成中…": "Generating…",
  "有 {p0} 个离线任务草稿": "Offline drafts: {p0}",
  "网络恢复后可继续提交。":
    "You can submit them when the connection is restored.",
  恢复: "Restore",
  已预填上一次的提示词: "Your previous prompt has been filled in",
  "改一下再点「生成」就能跑变体。":
    "Edit it and click Generate to create a variation.",
  "{p0} · {p1} · 在「任务」里查看进度":
    "{p0} · {p1} · Follow progress in Tasks",
  "在「任务」里查看": "View in Tasks",
  已保存到离线队列: "Saved to the offline queue",
  "当前共有 {p0} 个待恢复草稿。": "Drafts waiting to be restored: {p0}.",
  将设计交给每一个人: "Design for everyone",
  "查看队列 (": "View queue (",
  最近的作品: "Recent creations",
  "查看全部 ›": "View all ›",
  自动: "Auto",
  低: "Low",
  中: "Medium",
  高: "High",
  "超高（2.5）": "Extra high (2.5)",
  "最高（2.5）": "Maximum (2.5)",
  将清除: "This will clear ",
  条: " records",
  "当前已加载的已完成 / 已失败任务。远端 Origin/Archive 不会被删除，此操作不可撤销。":
    " from the loaded completed / failed tasks. Remote Origin/Archive files will remain. This cannot be undone.",
  "{p0}失败": "{p0} failed",
  生成队列: "Generation queue",
  任务总数: "Total tasks",
  "搜索提示词 / Job ID / Provider": "Search prompt / Job ID / Provider",
  搜索任务: "Search tasks",
  清空搜索: "Clear search",
  加载中: "Loading",
  正在获取任务列表: "Loading task list",
  还没有任务: "No tasks yet",
  无匹配结果: "No matching results",
  "没有找到匹配的任务。": "No matching tasks were found.",
  "在「生成」里写一句提示词，任务会出现在这里。":
    "Write a prompt in Generate. Your tasks will appear here.",
  "切换筛选标签或清除条件再试。":
    "Change the filter or clear the search and try again.",
  去写第一句: "Write your first prompt",
  加载更多: "Load more",
  "点击行展开查看作品组；点单张图打开右侧详情。任务在后台依次处理。":
    "Expand a row to view its images. Click an image for details. Tasks run in the background in queue order.",
  "{p0}候选 {p1}": "{p0}Candidate {p1}",
  复制提示词: "Copy prompt",
  在系统查看器中打开: "Open in system viewer",
  打开图片: "Open image",
  删除任务: "Delete job",
  "{p0} 张图片": "Images: {p0}",
  "已完成 {p0}/{p1}": "Completed {p0}/{p1}",
  "候选 ": "Candidate ",
  "生成图片预览 · 候选 {p0}": "Generated image preview · Candidate {p0}",
  失败: "Failed",
  未生成: "Not generated",
  "候选 {p0} · 失败": "Candidate {p0} · Failed",
  "候选 {p0} · 未生成": "Candidate {p0} · Not generated",
  "候选 {p0}": "Candidate {p0}",
  "候选 {p0} · 等待生成": "Candidate {p0} · Waiting for generation",
  耗时: "Duration",
  创建时间: "Created",
  打开: "Open",
  图片位置: "Image location",
  复制图片位置: "Copy image location",
  存储投递: "Storage delivery",
  "上传 URL": "Upload URL",
  "复制上传 URL": "Copy upload URL",
  "当前候选还没有上传记录。": "No upload record for this candidate yet.",
  错误: "Error",
  错误详情: "Error details",
  复制错误详情: "Copy error details",
  显示详情: "Show details",
  字: "characters",
  高级信息: "Advanced information",
  "任务 ID": "Job ID",
  命令: "Command",
  已上传: "Uploaded",
  部分失败: "Partial failure",
  上传失败: "Upload failed",
  已回退: "Fallback used",
  待上传: "Waiting to upload",
  上传中: "Uploading",
  未配置: "Not configured",
  未命名图片: "Untitled image",
  选择一条记录: "Select a record",
  "点击左侧任意作品，查看图片和保存操作。":
    "Click an image on the left to view it and save it.",
  已生成: "Generated",
  缺失: "Missing",
  已排队: "Queued",
  开始执行: "Started",
  输出完成: "Output complete",
  上传结果: "Upload results",
  已取消: "Cancelled",
  通知已发送: "Notification sent",
  "作品 {p0} · {p1} / {p2}": "Image {p0} · {p1} / {p2}",
  作品详情: "Image details",
  "（无提示词）": "(No prompt)",
  复制路径: "Copy path",
  图片路径: "Image path",
  "在 Finder 中显示": "Show in Finder",
  "再来一次（用相同参数预填生成屏）":
    "Generate again (fill the form with the same parameters)",
  再来一次: "Generate again",
  "发送到编辑（作为参考图）": "Send to editor (as a reference)",
  "这是包含 {p0} 张图的任务，删除会移除本地任务记录和全部 {p1} 张图；远端 Origin/Archive 不会被删除，且无法分别删除单张。":
    "This job contains {p0} images. Deleting it removes the local job record and all {p1} images. Remote Origin/Archive files will remain. Individual images cannot be deleted separately.",
  "这会删除本地任务记录和这张图；远端 Origin/Archive 不会被删除。桌面端本地文件会先移到回收站。":
    "This deletes the local job record and this image. Remote Origin/Archive files will remain. Desktop files are first moved to the trash.",
  "删除任务？": "Delete job?",
  "查看第 {p0} 张大图": "View image {p0} at full size",
  "第 {p0} 张": "Image {p0}",
  上一张: "Previous",
  下一张: "Next",
  文件大小: "File size",
  任务命令: "Job command",
  更新时间: "Updated",
  文件路径: "File path",
  存储位置: "Storage location",
  用默认应用打开: "Open with default app",
  恢复状态: "Recovery status",
  "响应完整接收：": "Full response received: ",
  是: "Yes",
  "否 / 不确定": "No / Unknown",
  时间线: "Timeline",
  "图生图 · 局部编辑": "Image-to-image · Local edit",
  图生图: "Image-to-image",
  原始请求: "Original request",
  文生图: "Text-to-image",
  "{p0} 张输入参考图": "Input reference images: {p0}",
  "{p0} 张参考图": "Reference images: {p0}",
  生成结果: "Generated result",
  输入参考图: "Input references",
  输入: "Input",
  输出: "Output",
  对比输入与输出: "Compare input and output",
  "参考图 {p0}": "Reference {p0}",
  "拖动滑块对比输入参考图与生成结果。":
    "Drag the slider to compare the input reference with the generated result.",
  "这个任务共有 {p0} 张图": "Images in this job: {p0}",
  "共 {p0} 张": "Total: {p0}",
  收起提示词: "Collapse prompt",
  展开提示词: "Expand prompt",
  部分图片生成失败: "Some images failed to generate",
  任务失败: "Job failed",
  复制完整错误: "Copy full error",
  "查看第 {p0} 张": "View image {p0}",
  "图片生成完成后会显示在这里。":
    "Images will appear here when generation finishes.",
  "这个任务没有输出。": "This job has no outputs.",
  打开文件夹: "Open folder",
  将删除任务: "This will delete job ",
  "。远端 Origin/Archive 不会被删除。":
    ". Remote Origin/Archive files will remain.",
  "查看{p0}": "View {p0}",
  "{p0} · 等待生成": "{p0} · Waiting for generation",
  收起本批次: "Collapse batch",
  展开本批次: "Expand batch",
  重新生成: "Regenerate",
  "重新生成 · 将再次调用 API": "Regenerate · This makes another API call",
  正在重新生成任务: "Regenerating job",
  已重新生成: "Regenerated",
  "任务 {p0} 已进入队列，将再次调用 API。":
    "Job {p0} has been queued and will make another API call.",
  继续完成: "Finish from cache",
  "使用已收到的响应继续完成，不再次调用 API":
    "Finish using the received response without another API call",
  正在继续完成任务: "Finishing job from cache",
  已继续完成: "Finished from cache",
  "已使用本地缓存响应完成保存，未再次调用 API。":
    "Saved using the cached response without another API call.",
  "生成缺失的 {p0} 张": "Generate {p0} missing outputs",
  "只为缺失图片再次调用 API": "Make API calls only for missing images",
  正在生成缺失图片: "Generating missing images",
  缺失图片已补齐: "Missing images completed",
  "已有图片保持不变，只为缺失槽位发起新请求。":
    "Existing images are unchanged. New requests are made only for missing slots.",
  重新上传: "Upload again",
  "不重新生成，只重传本地已有图片":
    "Upload existing local images again without regenerating",
  正在重新上传: "Uploading again",
  已重新上传: "Uploaded again",
  "图片已在本地生成，本次未再次调用 API。":
    "The images were already generated locally. No additional API call was made.",
  仍有图片未补齐: "Some images are still missing",
  "任务 {p0} 已保存本次成功补齐的图片，但仍有槽位失败。":
    "Job {p0} saved the newly completed images, but some slots still failed.",
  补齐未完成: "Missing outputs could not be completed",
  "任务 {p0} 本次补齐失败，请查看错误详情后重试。":
    "Could not complete job {p0}. Review the error details before retrying.",
  "部分成功 {p0}/{p1}": "Partial success {p0}/{p1}",
  等待中: "Waiting",
  "{p0}/{p1} 张": "{p0}/{p1} images",
  "{p0} 张": "{p0} images",
  部分成功: "Partial success",
  当前浏览器: "This browser",
  服务端配置: "Server configuration",
  服务端环境变量: "Server environment variable",
  服务端钥匙串: "Server keychain",
  配置文件: "Configuration file",
  环境变量: "Environment variable",
  钥匙串: "Keychain",
  凭证已存在: "Credentials already exist",
  "已配置的凭证不能被覆盖，请换一个名称。":
    "Existing credentials cannot be overwritten. Choose another name.",
  凭证已更新: "Credentials updated",
  凭证已添加: "Credentials added",
  "{p0} 的配置已保存。": "Configuration saved for {p0}.",
  "{p0} 已设为默认凭证。": "{p0} is now the default credentials profile.",
  保存失败: "Could not save",
  添加失败: "Could not add",
  编辑凭证: "Edit credentials",
  添加凭证: "Add credentials",
  取消: "Cancel",
  "保存中…": "Saving…",
  保存修改: "Save changes",
  添加并设为默认: "Add and set as default",
  名称: "Name",
  "这个名称已存在，已配置的凭证不能覆盖。":
    "This name already exists. Existing credentials cannot be overwritten.",
  会显示在凭证列表里: "Shown in the credentials list",
  "例如 my-image-api": "e.g. my-image-api",
  类型: "Type",
  凭证类型: "Credentials type",
  "OpenAI 兼容": "OpenAI compatible",
  "OpenAI 官方": "OpenAI official",
  服务地址: "Service URL",
  模型: "Model",
  批量策略: "Batch strategy",
  "Codex 会由 App 自动并行生成多张":
    "The app generates multiple images in parallel for Codex",
  "不确定时选「App 自动并行」最稳": "Choose App parallel generation if unsure",
  "App 自动并行": "App parallel generation",
  适合批量生成: "Suitable for batch generation",
  接口一次返回多张: "API returns multiple images in one call",
  "OpenAI 官方可使用精确遮罩": "The official OpenAI API supports precise masks",
  "不确定时选「软选区参考」最稳": "Choose Soft selection reference if unsure",
  "适合当前 Codex 通道": "Suitable for the current Codex channel",
  不支持: "Not supported",
  "账号 ID": "Account ID",
  "留空会保留原值。": "Leave blank to keep the existing value.",
  "可留空，使用后端服务已登录账号":
    "Optional; uses the account signed in on the server",
  "可留空，使用桌面 App 已登录账号":
    "Optional; uses the account signed in on the desktop app",
  可选: "Optional",
  密钥保存方式: "Key storage",
  "留空会保留原密钥。": "Leave blank to keep the existing key.",
  环境变量名: "Environment variable name",
  钥匙串条目: "Keychain entry",
  "留空会保留钥匙串里的原密钥。":
    "Leave blank to keep the existing keychain secret.",
  网络代理: "Network proxy",
  默认跟随全局设置: "Uses global settings by default",
  该凭证的网络代理: "Proxy for these credentials",
  代理地址: "Proxy URL",
  绕过代理的主机: "Hosts that bypass the proxy",
  "可选，每行一个或逗号分隔": "Optional; one per line or comma-separated",
  "支持 http / https / socks5 / socks5h；socks5h:// 由代理端做 DNS 解析。保存后地址只回显 scheme://host:port，重填完整地址才更新密码。":
    "Supports http / https / socks5 / socks5h. With socks5h://, DNS is resolved by the proxy. Saved URLs show only scheme://host:port. Enter the full URL again to change its password.",
  "该供应商当前有单独的代理设置；保持「跟随全局」并保存即可清除它，恢复使用全局代理。":
    "This provider has its own proxy settings. Save with Use global settings to remove the override.",
  连接正常: "Connection successful",
  "{p0} 可以使用。": "{p0} is ready to use.",
  连接失败: "Connection failed",
  默认凭证已更新: "Default credentials updated",
  "之后会优先使用 {p0}。": "Future requests will use {p0} by default.",
  设置失败: "Could not update settings",
  凭证已删除: "Credentials deleted",
  删除失败: "Could not delete",
  "搜索凭证…": "Search credentials…",
  添加: "Add",
  "尚未添加任何凭证。点击「添加」开始。":
    "No credentials yet. Click Add to get started.",
  "凭证配置会保存在桌面 App 配置中，并和 CLI、Skill 共用。":
    "Credentials are saved in the desktop app configuration and shared with the CLI and Skill.",
  "凭证配置由后端服务维护，网页只负责管理和测试。":
    "Credentials are managed by the server. This page manages and tests them.",
  "API Key 只保留在当前浏览器数据中。":
    "API keys are stored only in this browser.",
  选择一个凭证: "Select credentials",
  "左侧列出所有已配置的凭证，点击查看详情或测试连接。":
    "All configured credentials are listed on the left. Select one to view details or test its connection.",
  查看失败: "Could not reveal",
  复制失败: "Could not copy",
  默认: "Default",
  内置: "Built-in",
  不可用: "Unavailable",
  测试连接: "Test connection",
  设为默认: "Set as default",
  "这个凭证在当前运行环境不可用。":
    "These credentials are unavailable in the current environment.",
  接入设置: "Connection settings",
  "— 使用内置": "— Use built-in",
  多张生成: "Multiple outputs",
  接口支持一次返回多张: "The API can return multiple images per call",
  "App 会自动并行生成多张": "The app generates multiple images in parallel",
  凭据: "Authentication",
  "这个凭证使用后端服务已登录的账号信息。":
    "These credentials use the account signed in on the server.",
  "这个凭证使用桌面 App 已登录的账号信息。":
    "These credentials use the account signed in on the desktop app.",
  "这个凭证没有可查看的 API Key。":
    "These credentials have no API key to reveal.",
  未设置: "Not set",
  隐藏密钥: "Hide key",
  查看密钥: "Reveal key",
  复制密钥: "Copy key",
  删除凭证: "Delete credentials",
  就绪: "Ready",
  测试中: "Testing",
  "编辑凭证 {p0}": "Edit credentials {p0}",
  "「字符矩阵」主题已解锁，可在「外观」里随时切换。":
    "Character Matrix is unlocked. Select it any time in Appearance.",
  "当前运行环境不支持 App 内更新":
    "In-app updates are unavailable in this environment",
  "静态 Page 和 Docker Web 仍按部署端更新。":
    "Static pages and Docker Web are updated through deployment.",
  已经是最新版本: "You are up to date",
  "当前版本 {p0}": "Current version {p0}",
  "可以直接下载并安装。": "You can download and install it now.",
  检查更新失败: "Could not check for updates",
  准备下载: "Preparing download",
  开始下载: "Starting download",
  "下载中 {p0}%": "Downloading {p0}%",
  下载中: "Downloading",
  正在安装: "Installing",
  安装更新失败: "Could not install update",
  "本地图像生成与编辑桌面客户端。":
    "Desktop client for local image generation and editing.",
  "连接后端服务的 Web 创作工作台。":
    "Web creation workspace connected to a server.",
  "浏览器直连的 Web 创作工作台。":
    "Web creation workspace with direct browser connections.",
  应用更新: "App updates",
  "桌面 App 使用 Tauri 官方更新器。":
    "The desktop app uses the official Tauri updater.",
  "可更新到 {p0}": "Version {p0} is available",
  检查桌面端更新: "Check for desktop updates",
  "有新版本时会下载签名更新包，安装完成后自动重启 App。":
    "When an update is available, the signed package is downloaded and installed. The app then restarts automatically.",
  安装中: "Installing",
  下载并重启: "Download and restart",
  检查中: "Checking",
  检查更新: "Check for updates",
  数据位置: "Data locations",
  "本地配置、历史和图片保存位置。只读信息。":
    "Read-only locations for local configuration, history, and images.",
  历史数据库: "History database",
  图片保存位置: "Image storage location",
  旧共享目录: "Legacy shared directory",
  配置目录: "Configuration directory",
  版本: "Version",
  "Web 前端和后端服务由部署端更新，页面内不安装桌面更新包。":
    "The Web frontend and server are updated through deployment. This page does not install desktop update packages.",
  "静态 Web 由站点部署更新，页面内不安装桌面更新包。":
    "Static Web is updated through site deployment. This page does not install desktop update packages.",
  "当前前端版本 v{p0}": "Current frontend version v{p0}",
  "后端服务更新后，刷新页面即可使用新的 Web 前端。":
    "Refresh the page after a server update to use the new Web frontend.",
  "站点发布后，刷新页面即可使用新的静态 Web 前端。":
    "Refresh the page after a site release to use the new static Web frontend.",
  服务端数据: "Server data",
  结果下载: "Result downloads",
  "任务历史和结果由后端服务维护，网页只提供预览和下载入口。":
    "Task history and results are managed by the server. This page provides previews and downloads.",
  "需要长期保留的图片，请使用下载按钮。":
    "Download images you want to keep long term.",
  结果获取: "Get results",
  "单图可直接下载，多图任务会打包为 ZIP 下载。":
    "Download individual images directly or a multi-image job as a ZIP file.",
  "偏好保存在桌面 App 配置里；并发上限会实时同步到后台队列。":
    "Preferences are saved in the desktop app configuration. The concurrency limit is synced to the queue immediately.",
  "网页不会显示服务器目录；需要结果文件时请使用下载按钮。":
    "Server directories are not shown in the browser. Use Download to get result files.",
  "需要结果文件时请使用下载按钮。": "Use Download to get result files.",
  当前主题: "Current theme",
  "纸感主题下用作描边强度。值越高边线越清晰。":
    "Controls outline strength for paper themes. Higher values make the borders clearer.",
  "霓虹主题下用作发光强度。值越高边光越明显。":
    "Controls glow strength for neon themes. Higher values make the glow stronger.",
  "玻璃面板的不透明度。值越低背景越能透出，值越高内容越易读。":
    "Panel opacity. Lower values reveal more of the background; higher values improve readability.",
  语言: "Language",
  界面语言: "Interface language",
  "跟随系统会在中文环境显示中文，其他环境显示英文。":
    "Use Chinese in a Chinese system locale and English everywhere else.",
  跟随系统: "System",
  简体中文: "简体中文",
  主题: "Theme",
  界面版本: "Interface",
  "经典三栏会复用旧工作台外观，并禁用常驻动态背景以降低资源占用。":
    "The classic three-column workspace uses the original layout and disables animated backgrounds to reduce resource use.",
  "现代界面使用主题背景、玻璃胶囊和作品墙；适合视觉调试。":
    "The modern interface uses themed backgrounds, glass controls, and an image gallery.",
  现代: "Modern",
  经典: "Classic",
  主题预设: "Theme presets",
  "一键切换背景动效、配色、面板风格；字体和密度也会跟着调到主题推荐值。想禁用所有动效，切到「网格灰」或在 macOS 辅助功能里开启「减弱动态效果」。":
    "Switch background effects, colors, and panel style together. Fonts and density follow the preset's recommendations. To turn off animation, choose Grid Gray or enable Reduce Motion in macOS Accessibility.",
  面板透明度: "Panel opacity",
  亮暗主题: "Light / dark theme",
  "只影响经典工作台；现代界面的主题仍由主题预设控制。":
    "Applies to the classic workspace. Modern colors are controlled by theme presets.",
  经典亮暗主题: "Classic light / dark theme",
  暗色: "Dark",
  亮色: "Light",
  排版: "Typography",
  "主题切换会把字体和密度调到推荐值；下面的设置会覆盖推荐。":
    "Switching themes applies the recommended font and density. The settings below override them.",
  字体: "Font",
  "主题推荐：{p0}。": "Recommended by theme: {p0}.",
  系统: "System",
  等宽: "Monospace",
  衬线: "Serif",
  界面密度: "Interface density",
  紧凑: "Compact",
  舒适: "Comfortable",
  外观: "Appearance",
  存储: "Storage",
  网络: "Network",
  模板: "Templates",
  日志: "Logs",
  关于: "About",
  "无 TLS": "No TLS",
  本地: "Local",
  "百度网盘 OpenAPI": "Baidu Netdisk OpenAPI",
  "123 网盘 OpenAPI": "123Pan OpenAPI",
  服务器目录: "Server directory",
  个人对接: "Personal app",
  "OAuth 对接": "OAuth",
  "client 对接": "Client credentials",
  "accessToken 对接": "Access token",
  服务器: "Server",
  本机: "This device",
  仅服务器: "Server only",
  仅本机: "This device only",
  "图片只保存在{p0}结果库；不复制到云端。":
    "Images stay in the result library on {p0}; they are not copied to the cloud.",
  "{p0}为主，云端备份": "{p0} + cloud backup",
  "{p0}为原图，同时异步复制到一个或多个云端归档（双保险）。":
    "Originals stay on {p0} and are copied asynchronously to one or more cloud archives.",
  云端为主: "Cloud primary",
  "云端为原图，{p0}仅作上传缓冲；适合多设备共享。":
    "Originals stay in the cloud. {p0} is used only as an upload buffer. Suitable for sharing across devices.",
  仅推送到云端: "Push to cloud only",
  "{p0}为原图，云端目标只接收推送（如 Webhook，不可回读）。":
    "Originals stay on {p0}. Cloud targets only receive uploads, such as webhooks, and cannot be read back.",
  不清理: "Never clean up",
  归档成功后清理: "Clean up after successful archive",
  按保留天数清理: "Clean up by retention period",
  按上限大小清理: "Clean up by size limit",
  直接填写: "Enter directly",
  系统钥匙串: "System keychain",
  "百度网盘 OpenAPI 对接条件：": "Baidu Netdisk OpenAPI requirements:",
  "创建个人应用，并开通网盘上传权限。":
    "Create a personal app and enable file upload permissions.",
  "填写 App Key + Secret Key + Refresh Token，或长期 Access Token。":
    "Provide App Key + Secret Key + Refresh Token, or a long-lived Access Token.",
  "上传路径位于 /apps/{应用名}/，应用名需与开放平台一致。":
    "Files are uploaded under /apps/{app-name}/. The app name must match the developer platform.",
  "123 网盘 OpenAPI 对接条件：": "123Pan OpenAPI requirements:",
  "填写长期 Access Token；或配置 clientID + clientSecret。":
    "Provide a long-lived Access Token or configure clientID + clientSecret.",
  "父目录 ID 默认 0，表示根目录。":
    "Parent directory ID defaults to 0, the root directory.",
  "直链是可选增强；未开通时仍会上传成功，只是不返回公开 URL。":
    "Direct links are optional. Uploads still succeed without them, but no public URL is returned.",
  "可选。": "Optional.",
  "仅当此目录已经通过 Nginx、CDN 或静态文件服务映射成可访问地址时填写。":
    "Use only if this directory is already exposed through Nginx, a CDN, or a static file server.",
  "上传记录会用它拼出图片 URL；留空时仍会保存到目录。":
    "Upload records use this to build image URLs. Files are still saved to the directory if it is blank.",
  下载: "Downloads",
  文稿: "Documents",
  其他文件夹: "Other folder",
  直连: "Direct",
  自定义: "Custom",
  跟随全局: "Use global settings",
  强制直连: "Force direct connection",
  凭证配置: "Credentials",
  "管理用于图像生成的供应商和 API Key":
    "Manage providers and API keys for image generation",
  "液态背景、字体与界面密度":
    "Animated backgrounds, fonts, and interface density",
  "同时执行几个任务、结束后怎么提醒":
    "Concurrent tasks and completion notifications",
  保存与归档: "Save and archive",
  "图片保存位置，以及是否自动归档到其他存储":
    "Image locations and automatic archiving to other storage",
  "供应商和 API 请求走系统代理、直连还是自定义代理":
    "System, direct, or custom proxy settings for provider and API requests",
  提示词模板: "Prompt templates",
  管理可复用的生成和编辑提示词:
    "Manage reusable generation and editing prompts",
  "查看运行诊断日志，排查生成失败的原因":
    "View diagnostic logs to investigate generation failures",
  "关于 / 更新": "About / Updates",
  "版本、更新和数据位置": "Version, updates, and data locations",
  "{p0} 来源": "{p0} source",
  "{p0}，留空保留": "{p0}; leave blank to keep",
  "如 OPENAI_API_KEY": "e.g. OPENAI_API_KEY",
  "由部署者注入（docker compose env / systemd unit / 启动脚本等）；改完通常需重启服务才生效。":
    "Injected by the operator through Docker Compose, systemd, or a startup script. Changes usually require a service restart.",
  当前使用: "Current",
  "连接正常 · 重新测试": "Connection successful · Test again",
  "连接失败 · 重新测试": "Connection failed · Test again",
  "测试 {p0} 的连接": "Test connection for {p0}",
  "编辑 {p0}": "Edit {p0}",
  设为默认凭证: "Set as default credentials",
  使用: "Use",
  "删除凭证「{p0}」": 'Delete credentials "{p0}"',
  "此操作无法撤销。": "This cannot be undone.",
  还没有配置凭证: "No credentials configured",
  "支持 OpenAI / Azure / 自定义供应商。":
    "Supports OpenAI, Azure, and custom providers.",
  有未保存的改动: "Unsaved changes",
  保存: "Save",
  打开目录: "Open directory",
  在访达中显示: "Show in Finder",
  路径: "Path",
  "桌面端更新、本地配置和数据路径":
    "Desktop updates, local configuration, and data paths",
  "Web 版本、部署更新和服务端数据":
    "Web version, deployment updates, and server data",
  "静态 Web 版本和浏览器数据": "Static Web version and browser data",
  警告: "Warning",
  信息: "Info",
  调试: "Debug",
  "运行诊断日志，便于排查生成失败的原因。":
    "Diagnostic logs for investigating generation failures.",
  此环境不支持日志: "Logs are unavailable in this environment",
  "静态 Web 版本没有本机日志文件，请使用桌面 App 或自托管的 Docker 后端查看诊断日志。":
    "Static Web has no local log files. Use the desktop app or a self-hosted Docker server to view diagnostic logs.",
  没有可导出的日志: "No logs to export",
  日志目录: "Log directory",
  "服务器日志目录路径不可用。": "The server log directory path is unavailable.",
  无法打开日志文件夹: "Could not open the log folder",
  日志设置: "Log settings",
  "控制诊断日志的详细程度。": "Control diagnostic log detail.",
  "详细日志（调试）": "Detailed logs (debug)",
  "开启后会额外记录 debug 级别的事件，便于深入排查；默认仅记录信息及以上。":
    "Also record debug events for deeper investigation. By default, only info and higher levels are recorded.",
  保存日志设置失败: "Could not save log settings",
  日志级别过滤: "Filter by log level",
  刷新: "Refresh",
  导出: "Export",
  "正在加载日志…": "Loading logs…",
  "加载日志失败：": "Could not load logs: ",
  未知错误: "Unknown error",
  "暂无日志记录。": "No log records yet.",
  "如需更详细的事件，可开启上方的「详细日志」。":
    "Enable Detailed logs above to record more events.",
  保存与试发: "Save and test",
  "试发一条假数据，使用已保存的配置。":
    "Send sample data using the saved configuration.",
  试发完成: "Test complete",
  试发失败: "Test failed",
  试发取消: "Test cancelled",
  邮件通知: "Email notifications",
  "密码支持直接填写 / 环境变量 / 系统钥匙串。":
    "Enter a password directly, or use an environment variable or the system keychain.",
  邮件发件人: "Email sender",
  "SMTP 用户名": "SMTP username",
  "SMTP 密码": "SMTP password",
  邮件收件人: "Email recipients",
  本地提示: "Local notifications",
  "右上角弹提示；系统通知首次会请求权限。":
    "Show an in-app alert. System notifications request permission the first time.",
  应用内: "In-app",
  系统通知: "System notifications",
  触发状态: "Trigger statuses",
  "哪些结果会通知。": "Choose which results trigger a notification.",
  完成: "Completed",
  "转发到你自己的服务地址，可加请求头鉴权。":
    "Forward to your own service URL. Request headers can provide authentication.",
  "暂无 webhook。": "No webhooks yet.",
  "删除 webhook": "Delete webhook",
  "Webhook 名称": "Webhook name",
  "{p0} 值": "{p0} value",
  "删除 header": "Delete header",
  "添加 Header": "Add header",
  "添加 Webhook": "Add webhook",
  系统通知权限未开启: "System notification permission is disabled",
  "请在系统设置中允许 GPT Image 2 发送通知。":
    "Allow GPT Image 2 to send notifications in system settings.",
  通知中心已保存: "Notification settings saved",
  保存通知中心失败: "Could not save notification settings",
  测试通知失败: "Test notification failed",
  测试通知已取消: "Test notification cancelled",
  测试通知完成: "Test notification complete",
  "应用内通知已触发。": "In-app notification triggered.",
  应用内通知已触发: "In-app notification triggered",
  "GPT Image 2 测试通知": "GPT Image 2 test notification",
  "这是一条失败状态的系统通知测试。":
    "This is a system notification test for a failed job.",
  "这是一条取消状态的系统通知测试。":
    "This is a system notification test for a cancelled job.",
  "这是一条完成状态的系统通知测试。":
    "This is a system notification test for a completed job.",
  系统通知已发送: "System notification sent",
  系统通知未发送: "System notification not sent",
  没有可发送的方式: "No notification method available",
  "通知中心已关或未选任何状态 / 方式，不会发出。":
    "Notifications are disabled or no status / method is selected. Nothing will be sent.",
  "未配置邮件 / 回调；已试发本地通知。":
    "No email or webhook configured. Local notifications have been tested.",
  试发已完成: "Test complete",
  试发未全部成功: "Some test notifications failed",
  通知中心: "Notifications",
  "任务结束时提醒你 — 应用内、系统、邮件或回调。":
    "Notify when tasks finish: in-app, system, email, or webhook.",
  "当前环境只能弹应用内 / 系统通知；邮件和回调需要桌面 App 或自建后端。":
    "This environment supports in-app and system notifications only. Email and webhooks require the desktop app or a self-hosted server.",
  编辑模板: "Edit template",
  新建模板: "New template",
  "作用域控制模板出现在哪些创作页面；通用模板会出现在所有页面。":
    "Scope controls which creation pages show this template. Common templates appear on every page.",
  模板名称: "Template name",
  选择分组: "Choose group",
  模板作用域: "Template scope",
  "写入要复用的提示词...": "Enter a reusable prompt...",
  保存模板: "Save template",
  添加模板: "Add template",
  分组: "Groups",
  "分组可自定义；删除分组会删除其中模板。":
    "Groups are customizable. Deleting a group also deletes its templates.",
  新分组名称: "New group name",
  "暂无分组，添加一个分组后即可创建模板。":
    "No groups yet. Add a group to create templates.",
  当前: "Current",
  切换: "Switch",
  分组名称: "Group name",
  删除分组: "Delete group",
  "模板 · {p0}": "Templates · {p0}",
  "默认模板和默认分组与普通数据一样，可编辑、复制或删除。":
    "Default templates and groups are editable data. You can edit, duplicate, or delete them.",
  这个分组还没有模板: "No templates in this group",
  "在上方新建模板并保存到当前分组。":
    "Create a template above and save it to this group.",
  复制: "Duplicate",
  复制模板: "Duplicate template",
  删除模板: "Delete template",
  还没有分组: "No groups yet",
  "先添加分组，再创建提示词模板。":
    "Add a group before creating prompt templates.",
  选择模板图标和颜色: "Choose template icon and color",
  "选择图标：{p0}": "Choose icon: {p0}",
  "选择颜色：{p0}": "Choose color: {p0}",
  "删除分组「{p0}」": 'Delete group "{p0}"',
  "会同时删除这个分组里的 {p0} 个模板。":
    "This also deletes {p0} templates in the group.",
  "{p0} 副本": "{p0} copy",
  模板已复制: "Template duplicated",
  "删除模板「{p0}」": 'Delete template "{p0}"',
  请先创建一个分组: "Create a group first",
  请填写模板名称: "Enter a template name",
  请填写提示词内容: "Enter a prompt",
  模板已更新: "Template updated",
  模板已添加: "Template added",
  导入提示词模板: "Import prompt templates",
  "导入会替换当前所有分组和模板。":
    "Importing replaces all current groups and templates.",
  导入: "Import",
  提示词模板已导入: "Prompt templates imported",
  "{p0} 个分组，{p1} 个模板。": "Groups: {p0}; templates: {p1}.",
  导入失败: "Import failed",
  "模板会插入到生成 / 编辑提示词的光标位置；新模板默认作用域为通用。":
    "Templates are inserted at the cursor in generation or editing prompts. New templates default to Common scope.",
  "导入 JSON": "Import JSON",
  "导出 JSON": "Export JSON",
  代理设置已保存: "Proxy settings saved",
  保存代理设置失败: "Could not save proxy settings",
  "供应商和 API 请求的全局出站代理；单个凭证可在编辑里另行覆盖。":
    "Global outbound proxy for provider and API requests. Individual credentials can override it.",
  代理模式: "Proxy mode",
  "跟随系统读取环境变量，直连忽略所有代理，自定义则使用下面的地址。":
    "System reads environment variables. Direct ignores all proxies. Custom uses the URL below.",
  "可选。每行一个，或用逗号分隔；命中的主机会直连。":
    "Optional. One host per line or comma-separated. Matching hosts connect directly.",
  "支持 http / https / socks5 / socks5h。推荐":
    "Supports http / https / socks5 / socks5h. Recommended: ",
  "—— 由代理端做 DNS 解析，可避免本机 DNS 污染（国内场景常用）。":
    " — DNS is resolved by the proxy, avoiding local DNS interference.",
  含账号密码时填完整:
    "For username and password authentication, enter the full ",
  "；出于安全，保存后只回显": ". After saving, only ",
  "，重新填写完整地址才会更新密码。":
    " is displayed. Enter the full URL again to change its password.",
  保存位置已更新: "Save location updated",
  保存位置更新失败: "Could not update save location",
  保存位置: "Save location",
  "生成后的图片会保存在这里。": "Generated images are saved here.",
  "当前运行环境会使用浏览器下载位置，无法指定本机文件夹。":
    "This environment uses the browser's download location. You cannot choose a local folder here.",
  保存设置: "Save settings",
  默认保存到: "Default save folder",
  "生成完成后，图片会放到这个文件夹。":
    "Images are placed in this folder after generation.",
  默认保存文件夹: "Default save folder",
  按所选模式自动决定: "Determined automatically by the selected mode",
  浏览文件夹: "Browse folders",
  复制默认保存位置: "Copy default save location",
  默认保存位置: "Default save location",
  自定义保存文件夹: "Custom save folder",
  目前没有任务在队列里: "No tasks in the queue",
  "当前 {p0} 个在跑，{p1} 个排队": "Running: {p0}; queued: {p1}",
  创作草稿已清除: "Creation drafts cleared",
  清除草稿失败: "Could not clear drafts",
  队列: "Queue",
  "一次最多并行几个，避免占满网络或 CPU。":
    "Limit concurrent tasks to avoid saturating the network or CPU.",
  同时执行数: "Concurrent tasks",
  草稿: "Drafts",
  "保留生成 / 编辑页未提交的内容（参数、参考图、遮罩）。":
    "Keep unsubmitted prompts, parameters, references, and masks from Generate and Edit.",
  保留创作草稿: "Keep creation drafts",
  "刷新或重启后仍能恢复未提交的内容；关闭会清空。":
    "Restore unsubmitted content after refresh or restart. Disabling this clears drafts.",
  存储配置未完成: "Storage configuration is incomplete",
  结果存储已保存: "Result storage saved",
  保存结果存储失败: "Could not save result storage",
  测试失败: "Test failed",
  存储目标可用: "Storage target available",
  存储目标不可用: "Storage target unavailable",
  测试存储目标失败: "Could not test storage target",
  "管理员提供了默认存储策略，你可以按需要调整。":
    "The administrator provides a default storage policy. You can adjust it as needed.",
  "存储策略由管理员管理，当前配置会按策略锁定 Origin、归档和模式。":
    "Storage policy is managed by the administrator. Origin, archives, and mode are locked by the policy.",
  结果归档策略: "Result archive policy",
  "网页版只存在浏览器本地，要上传云端请用桌面 App 或自建后端。":
    "Static Web stores data in this browser. Use the desktop app or a self-hosted server for cloud uploads.",
  "选择原图存放在哪儿，以及要不要复制到其他位置。":
    "Choose where to keep originals and whether to copy them elsewhere.",
  管理员默认值: "Administrator defaults",
  由管理员管理: "Managed by administrator",
  "管理员提供了默认策略，你仍可按当前工作流调整。":
    "The administrator provides a default policy. You can adjust it for your workflow.",
  "管理员策略会在保存和任务执行时保持生效。":
    "Administrator policy remains active when saving settings and running tasks.",
  模式: "Mode",
  "决定原图位置和归档行为。": "Controls original image location and archiving.",
  "需要先在下方添加一个支持回读的存储位置（local / S3 / WebDAV / SFTP）。":
    "Add storage that supports readback below first (local / S3 / WebDAV / SFTP).",
  "「云端为主」需要先在下方「位置列表」添加一个支持回读的存储（local / S3 / WebDAV / SFTP），仅推送的目标（如 HTTP/Webhook）不能作为原图。":
    "Cloud primary requires a location with readback support (local / S3 / WebDAV / SFTP). Push-only targets such as HTTP/webhooks cannot hold the originals.",
  云端原图位置: "Cloud original location",
  "必须是支持回读的存储类型；HTTP/Webhook 等仅推送的目标不可作为原图。":
    "Must support readback. Push-only targets such as HTTP/webhooks cannot hold originals.",
  "没有可用的原图位置；请先在下方添加一个支持回读的存储（local / S3 / WebDAV / SFTP）。":
    "No location for originals is available. Add storage with readback support below (local / S3 / WebDAV / SFTP).",
  请选择原图位置: "Choose original location",
  归档目标: "Archive targets",
  额外归档: "Additional archives",
  推送目标: "Push targets",
  "任务完成后，会复制到这里。": "Copy here after a task finishes.",
  "除原图外，还要异步复制到这些位置（可选）。":
    "Optionally copy to these additional locations asynchronously.",
  "任务完成后推送到这些位置。":
    "Push to these locations after a task finishes.",
  "暂无可选归档位置。": "No archive locations available.",
  "个云端位置已配置但不启用。": " cloud locations are configured but inactive.",
  清理策略: "Cleanup policy",
  "{p0}缓存会在远端 Origin 与归档均完成后才清理。":
    "The cache on {p0} is cleared only after remote Origin and all archives are complete.",
  "只有云端为主模式会自动清理本地缓存。":
    "Only Cloud primary automatically cleans up the local cache.",
  保留天数: "Retention days",
  "本地缓存上限 GB": "Local cache limit (GB)",
  并行上传图片数: "Concurrent image uploads",
  "一次最多同时上传几张图。": "Maximum images uploaded at once.",
  同图并行位置数: "Concurrent locations per image",
  "同一张图最多同时传到几个位置。":
    "Maximum locations an image is uploaded to at once.",
  位置列表: "Locations",
  添加上传位置: "Add upload location",
  "当前上传位置：": "Current upload location: ",
  查看对接条件: "View requirements",
  必填: "Required",
  本地目录: "Local directory",
  上传位置名称: "Upload location name",
  上传位置类型: "Upload location type",
  测试: "Test",
  删除上传位置: "Delete upload location",
  "服务器上的路径；docker 部署需挂载为 volume。":
    "A path on the server. Docker deployments require a volume mount.",
  "浏览{p0}": "Browse {p0}",
  公开访问前缀: "Public URL prefix",
  查看公开访问前缀说明: "About the public URL prefix",
  "用于生成可访问图片 URL；没有静态访问服务时留空。":
    "Used to build accessible image URLs. Leave blank without a static file service.",
  "对外访问前缀（可选）": "Public URL prefix (optional)",
  "S3 对外访问前缀": "S3 public URL prefix",
  "WebDAV 对外访问前缀": "WebDAV public URL prefix",
  "JSON 中公开 URL 的字段路径": "JSON field path for public URL",
  "删除 HTTP header": "Delete HTTP header",
  "SFTP 对外访问前缀": "SFTP public URL prefix",
  "SHA256 指纹": "SHA256 fingerprint",
  "SFTP 服务器 SHA256 指纹": "SFTP server SHA256 fingerprint",
  百度网盘对接方式: "Baidu Netdisk authentication",
  "个人对接只需要长期 Access Token。":
    "Personal apps need only a long-lived Access Token.",
  "OAuth 对接使用应用凭证换取访问令牌。":
    "OAuth exchanges app credentials for an access token.",
  应用目录名: "App directory name",
  百度网盘应用目录名: "Baidu Netdisk app directory name",
  百度网盘远端目录: "Baidu Netdisk remote directory",
  "公开基础 URL（可选）": "Public base URL (optional)",
  "百度网盘公开基础 URL": "Baidu Netdisk public base URL",
  "百度网盘 Access Token": "Baidu Netdisk Access Token",
  "百度网盘 App Key": "Baidu Netdisk App Key",
  "百度网盘 Secret Key": "Baidu Netdisk Secret Key",
  "百度网盘 Refresh Token": "Baidu Netdisk Refresh Token",
  "123 网盘对接方式": "123Pan authentication",
  "client 对接使用 clientID + clientSecret。":
    "Client authentication uses clientID + clientSecret.",
  "accessToken 对接只需要长期 accessToken。":
    "Token authentication needs only a long-lived accessToken.",
  "123 网盘父目录 ID": "123Pan parent directory ID",
  上传后尝试获取直链: "Try to get a direct link after uploading",
  "123 网盘 clientID": "123Pan clientID",
  "123 网盘 clientSecret": "123Pan clientSecret",
  "123 网盘 accessToken": "123Pan accessToken",
  "{p0}张": "{p0} images",
  参数: "Parameters",
  生成参数: "Generation parameters",
  关闭参数: "Close parameters",
  "auto 或 1536x1024": "auto or 1536x1024",
  保存图片: "Save image",
  "候选 {p0}{p1}": "Candidate {p0}{p1}",
  "，已选中": ", selected",
  插入提示词模板: "Insert prompt template",
  搜索模板: "Search templates",
  "没有匹配的模板，可在设置里添加。":
    "No matching templates. Add one in Settings.",
  "（空模板）": "(Empty template)",
  "{p0} 个任务进行中": "Tasks running: {p0}",
  展开选项: "Expand options",
  关闭: "Close",
  更多: "More",
  "切换到第 {p0} 张": "Switch to image {p0}",
  请选择: "Choose an option",
  剪切失败: "Could not cut",
  剪切: "Cut",
  粘贴: "Paste",
  全选: "Select all",
  "当前运行环境不支持修改本机路径。":
    "This environment cannot change local paths.",
  "当前运行环境不支持修改存储配置。":
    "This environment cannot change storage configuration.",
  "当前运行环境不支持测试存储目标。":
    "This environment cannot test storage targets.",
  "当前运行环境不支持打开日志文件夹。":
    "This environment cannot open the log folder.",
  确认: "Confirm",
  无法读取拖入的图片: "Could not read dropped images",
  "无法启用 Tauri 拖拽上传": "Could not enable Tauri image drop support",
  操作失败: "Action failed",
  "当前浏览器数据空间接近上限。": "This browser's storage is almost full.",
  浏览器数据空间不足: "Insufficient browser storage",
  "1 张图片": "1 image",
  查看: "View",
  "{p0}部分完成": "{p0} partially complete",
  "{p0}完成": "{p0} complete",
  任务已取消: "Job cancelled",
  浏览器默认下载位置: "Browser default download location",
  "已校验本地 toast / 系统通知配置；邮件和 webhook 需要桌面 App 或服务端 Web。":
    "Local in-app and system notification settings verified. Email and webhooks require the desktop app or a Web server.",
  "静态 Web 仅会把结果保存在当前浏览器数据中，不会写入服务器或本机目录。":
    "Static Web saves results only in this browser's storage, not to a server or local directory.",
  "远端存储上传需要桌面 App 或服务端 Web；静态 Web 不会保存远端密钥。":
    "Remote storage uploads require the desktop app or a Web server. Static Web does not store remote storage secrets.",
  "静态 Web 不能读取 Codex 登录态，请使用桌面 App 或 Docker。":
    "Static Web cannot read your Codex login. Use the desktop app or Docker.",
  "静态 Web 不能使用 Codex 凭证，请改用桌面 App 或 Docker。":
    "Static Web cannot use Codex credentials. Use the desktop app or Docker.",
  "凭证「{p0}」缺少 API Key。": 'Credentials "{p0}" are missing an API key.',
  "静态 Web 只支持保留在当前浏览器数据中的 API Key。":
    "Static Web supports API keys stored in this browser only.",
  "凭证「{p0}」的 API Key 为空。": 'The API key for "{p0}" is empty.',
  "没有找到可下载的图片。": "No images were found to download.",
  "没有可下载的图片。": "No images available to download.",
  "服务地址不能为空。": "Service URL cannot be empty.",
  服务地址已省略: "Service URL omitted",
  " 当前 Base URL 域名：{p0}。": " Current Base URL domain: {p0}.",
  "上游服务域名无法解析或回源失败（Cloudflare 1016/530）。请检查 Base URL 是否写错，或换一个当前可公网访问的服务地址。{p0}":
    "The upstream service domain could not be resolved or reached (Cloudflare 1016/530). Check the Base URL or use a publicly reachable service URL.{p0}",
  "图片接口没有返回 b64_json 或 url。":
    "The image API returned neither b64_json nor url.",
  "接口响应里没有生成图片。": "The response contains no generated images.",
  "{p0} 个子任务失败：{p1}": "Failed subtasks: {p0}. Details: {p1}",
  "当前浏览器数据空间接近上限，请清理历史或导出图片。":
    "Browser storage is almost full. Clear history or export images.",
  "任务已取消。": "Job cancelled.",
  "页面刷新或关闭，浏览器任务已中断。":
    "The browser job was interrupted by a page refresh or close.",
  "请求可能已经到达服务商，但浏览器没有收到响应。为避免重复生成或重复扣费，本次不会自动切换中转站重试；请先到服务商后台确认结果，再决定是否手动重试。":
    "The request may have reached the provider, but the browser received no response. To avoid duplicate generation or charges, it will not automatically retry through the relay. Check the provider's dashboard before retrying manually.",
  "服务地址不是有效的 URL。": "The service URL is invalid.",
  "API 请求地址不能包含查询参数或片段。":
    "API request URLs cannot contain query parameters or fragments.",
  "中转站只支持模型检查、图片生成、图片编辑和图片下载。":
    "The relay supports only model checks, image generation, image editing, and image downloads.",
  "本站中转服务尚未准备好，请稍后再试或改用支持浏览器 CORS 的服务地址。":
    "The relay is not ready. Try again later or use a service URL with browser CORS support.",
  "当前浏览器无法加载安全验证组件。":
    "This browser cannot load the security verification widget.",
  "安全验证组件加载超时，请检查网络后重试。":
    "The verification widget timed out. Check your connection and retry.",
  "安全验证组件加载失败，请稍后重试。":
    "The verification widget failed to load. Try again later.",
  "安全验证组件加载失败，请检查网络后重试。":
    "The verification widget failed to load. Check your connection and retry.",
  "当前浏览器无法显示安全验证组件。":
    "This browser cannot display the security verification widget.",
  正在进行中转站安全验证: "Verifying relay access",
  "安全验证未完成，请重试。":
    "Security verification is incomplete. Please retry.",
  "安全验证超时，请重试。": "Security verification timed out. Please retry.",
  "安全验证失败，请稍后重试。":
    "Security verification failed. Try again later.",
  "安全验证已过期，请重试。": "Security verification expired. Please retry.",
  "安全验证组件初始化失败，请稍后重试。":
    "Could not initialize the verification widget. Try again later.",
  "中转站安全会话建立失败，请稍后重试。":
    "Could not establish a secure relay session. Try again later.",
  "中转站返回了无法验证的响应，请稍后重试。":
    "The relay returned an unverifiable response. Try again later.",
  "中转站连接检查失败，请稍后重试。":
    "Relay connection check failed. Try again later.",
  "该服务商不允许浏览器直连，且本站中转暂时不可用。请稍后重试，或改用 Docker/App。":
    "This provider does not allow direct browser connections, and the relay is unavailable. Try again later or use Docker/the desktop app.",
  "凭证名称不能为空。": "Credentials name cannot be empty.",
  "静态 Web 不能添加 Codex 凭证，请使用桌面 App 或 Docker。":
    "Static Web cannot add Codex credentials. Use the desktop app or Docker.",
  "静态 Web 只支持 OpenAI-compatible API Key 凭证。":
    "Static Web supports OpenAI-compatible API key credentials only.",
  "静态 Web 只支持直接填写并保留在当前浏览器数据中的 API Key。":
    "Static Web supports directly entered API keys stored in this browser only.",
  "凭证「{p0}」已存在。": 'Credentials "{p0}" already exist.',
  "API Key 不能为空。": "API key cannot be empty.",
  "凭证「{p0}」还没有保存可查看的密钥。":
    'Credentials "{p0}" have no saved key to reveal.',
  "内置 Codex 提示不能删除。": "The built-in Codex hint cannot be deleted.",
  "浏览器模式不支持恢复，请重新生成。":
    "Recovery is unavailable in browser mode. Please generate again.",
  "浏览器模式请使用 ClipboardItem。": "Use ClipboardItem in browser mode.",
  "没有可打开的文件。": "No files to open.",
  "Web 不能打开文件夹，请使用桌面 App 查看文件位置。":
    "Web cannot open folders. Use the desktop app to view file locations.",
  "这个生成任务缺少 prompt，无法原样重试。":
    "This generation job has no prompt and cannot be retried unchanged.",
  "这个编辑任务缺少原始参考图，无法原样重试。":
    "This editing job has no original reference images and cannot be retried unchanged.",
  "这个任务类型暂不支持重试。": "Retry is not supported for this job type yet.",
  "浏览器模式暂不支持丢弃恢复任务。":
    "Browser mode cannot discard recovery jobs yet.",
  "浏览器模式不支持继续完成，请改用 Docker/App。":
    "Finishing from cache is unavailable in browser mode. Use Docker/the desktop app.",
  "下载图片失败：{p0} {p1}": "Image download failed: {p0} {p1}",
  "HTTP 模式不支持恢复，请重新生成。":
    "Recovery is unavailable in HTTP mode. Please generate again.",
  "HTTP 模式请使用浏览器内置剪贴板。":
    "Use the browser clipboard in HTTP mode.",
  "Web 页面不能打开服务端文件夹，请在服务器环境中查看。":
    "Web cannot open server folders. View them on the server.",
  已复制: "Copied",
  已保存: "Saved",
  刚刚: "Just now",
  "{p0} 分钟前": "{p0} min ago",
  "{p0} 小时前": "{p0} hr ago",
  运行中: "Running",
  排队中: "Queued",
  "Tauri 模式需要本地文件路径来复制图片。":
    "Tauri mode requires a local file path to copy an image.",
  "浏览器不支持 ClipboardItem，无法复制图片。":
    "This browser does not support ClipboardItem and cannot copy images.",
  "无法读取图片：HTTP {p0}": "Could not read image: HTTP {p0}",
  任务已删除: "Job deleted",
  已恢复: "Restored",
  恢复失败: "Could not restore",
  快速查看: "Quick Look",
  复制图片: "Copy image",
  已复制图片: "Image copied",
  "没有提示词。": "No prompt.",
  已复制提示词: "Prompt copied",
  复制文件路径: "Copy file path",
  复制链接: "Copy link",
  "没有可复制的路径或链接。": "No path or link to copy.",
  已复制路径: "Path copied",
  已复制链接: "Link copied",
  下载图片: "Download image",
  "已保存 {p0} 张图片": "Images saved: {p0}",
  已开始下载: "Download started",
  "无可定位的路径。": "No path to reveal.",
  "无可打开的路径。": "No path to open.",
  用作参考图: "Use as reference",
  用提示词编辑: "Edit with prompt",
  这个任务没有保存提示词: "This job has no saved prompt",
  在历史中查看任务: "View job in history",
  "分享…": "Share…",
  "这会删除本地任务记录和这张图；远端 Origin/Archive 不会被删除。":
    "This deletes the local job record and this image. Remote Origin/Archive files will remain.",
  不透明: "Opaque",
  由模型自行决定: "Let the model decide",
  "1:1 · 方图 1K": "1:1 · Square 1K",
  "1:1 · 方图 2K": "1:1 · Square 2K",
  "3:2 · 横图": "3:2 · Landscape",
  "2:3 · 竖图": "2:3 · Portrait",
  "16:9 · 横图 2K": "16:9 · Landscape 2K",
  "9:16 · 竖图 2K": "9:16 · Portrait 2K",
  "16:9 · 4K 横图": "16:9 · Landscape 4K",
  "9:16 · 4K 竖图": "9:16 · Portrait 4K",
  "21:9 · 超宽": "21:9 · Ultrawide",
  "21:9 · 超宽 2K": "21:9 · Ultrawide 2K",
  "Instagram 方": "Instagram square",
  "尺寸不能为空，可填 auto 或 WIDTHxHEIGHT。":
    "Size cannot be empty. Enter auto or WIDTHxHEIGHT.",
  "尺寸格式应为 auto 或 WIDTHxHEIGHT，例如 1536x1024。":
    "Size must be auto or WIDTHxHEIGHT, such as 1536x1024.",
  "宽高必须是正整数。": "Width and height must be positive integers.",
  "宽高都必须是 16 的倍数。": "Width and height must be multiples of 16.",
  "最长边不能超过 {p0}px。": "The longest edge cannot exceed {p0}px.",
  "总像素不能少于 {p0}。": "Total pixels must be at least {p0}.",
  "总像素不能超过 {p0}。": "Total pixels cannot exceed {p0}.",
  "长边和短边比例不能超过 3:1。": "The aspect ratio cannot exceed 3:1.",
  "输出数量必须是整数。": "Output count must be an integer.",
  "输出数量必须在 {p0}-{p1} 之间。":
    "Output count must be between {p0} and {p1}.",
  任务执行失败: "Job failed",
  未发现输出文件: "No output files found",
  "计划生成 {p0} 张，已收到 {p1} 张": "Planned outputs: {p0}; received: {p1}",
  "已生成并保存 {p0} 张图片": "Images generated and saved: {p0}",
  图片已生成并保存: "Image generated and saved",
  "这次计划生成 {p0} 张，但只收到 {p1} 张。":
    "Planned outputs: {p0}, but only {p1} were received.",
  "图片已保存，可以继续查看。": "Images are saved and ready to view.",
  灵感: "Inspiration",
  魔法: "Magic",
  图像: "Image",
  摄影: "Photography",
  人像: "Portrait",
  风景: "Landscape",
  配色: "Color",
  精修: "Retouch",
  选区: "Selection",
  构图: "Composition",
  抠图: "Cutout",
  产品: "Product",
  文字: "Text",
  光线: "Lighting",
  电影: "Cinema",
  贴纸: "Sticker",
  版式: "Layout",
  立体: "3D",
  文案: "Copywriting",
  风格: "Style",
  图库: "Gallery",
  整理: "Organize",
  日光: "Sunlight",
  通用: "Common",
  青: "Cyan",
  紫: "Violet",
  绿: "Green",
  橙: "Amber",
  玫: "Rose",
  灰: "Gray",
  新分组: "New group",
  新模板: "New template",
  产品摄影: "Product photography",
  "产品摄影：主体清晰的产品，纯白背景，柔光，居中构图，高清细节":
    "Product photography: a clearly defined product, pure white background, soft lighting, centered composition, and high-resolution detail",
  局部精修: "Local retouch",
  "保持整体风格不变，只优化选区细节，让材质更自然、边缘更干净。":
    "Keep the overall style unchanged. Refine only the selected details for more natural materials and cleaner edges.",
  通用质感: "Cinematic texture",
  "电影级光线，真实材质，清晰层次，避免过度锐化。":
    "Cinematic lighting, realistic materials, clear depth, and no excessive sharpening.",
  未命名分组: "Untitled group",
  示例: "Sample",
  未命名模板: "Untitled template",
  接口多图: "API batch",
  "App 并发多图": "App parallel generation",
  原生遮罩: "Native mask",
  参考图局部编辑: "Local edit with references",
  失败可分类: "Classifiable errors",
  "桌面 App": "Desktop app",
  本次结果文件夹: "Current result folder",
  保存选中: "Save selected",
  保存全部: "Save all",
  "正在保存图片…": "Saving images…",
  已保存全部图片: "All images saved",
  图片已保存: "Image saved",
  "已保存到你设置的文件夹。": "Saved to your configured folder.",
  正在保存任务图片: "Saving job images",
  服务端任务: "Server tasks",
  下载选中: "Download selected",
  下载全部: "Download all",
  "下载 ZIP": "Download ZIP",
  正在准备下载图片: "Preparing image downloads",
  "正在准备下载图片…": "Preparing image download…",
  已开始下载全部图片: "All image downloads started",
  已开始下载图片: "Image download started",
  "浏览器已开始下载图片。": "The browser has started downloading the images.",
  "正在准备任务 ZIP": "Preparing job ZIP",
  "已开始下载 ZIP": "ZIP download started",
  "浏览器已开始下载任务 ZIP。":
    "The browser has started downloading the job ZIP.",
  "静态 Web": "Static Web",
  当前浏览器数据: "This browser's data",
  "候选 {p0} 已保存在本次结果文件夹":
    "Candidate {p0} is saved in the current result folder",
  "候选 {p0} 保存在服务端任务中，可下载查看":
    "Candidate {p0} is stored in the server job and available to download",
  "候选 {p0} 保存在当前浏览器数据中，可下载查看":
    "Candidate {p0} is stored in this browser and available to download",
  "存储目标「{p0}」不存在。": 'Storage target "{p0}" does not exist.',
  未命名: "Untitled",
  "请填写{p0}。": "Enter {p0}.",
  "请填写 S3 bucket。": "Enter an S3 bucket.",
  "请填写 S3 Access Key ID。": "Enter an S3 Access Key ID.",
  "请填写 S3 Secret Access Key。": "Enter an S3 Secret Access Key.",
  "请填写 WebDAV URL。": "Enter a WebDAV URL.",
  "请填写 HTTP 上传 URL。": "Enter an HTTP upload URL.",
  "请填写 SFTP host。": "Enter an SFTP host.",
  "请填写 SFTP host key 指纹。": "Enter an SFTP host key fingerprint.",
  "请填写 SFTP username。": "Enter an SFTP username.",
  "请填写 SFTP 远端目录。": "Enter an SFTP remote directory.",
  "请填写 SFTP 密码或私钥。": "Enter an SFTP password or private key.",
  "请填写百度网盘应用目录名。": "Enter a Baidu Netdisk app directory name.",
  "请填写百度网盘 Access Token。": "Enter a Baidu Netdisk Access Token.",
  "请填写百度网盘 App Key。": "Enter a Baidu Netdisk App Key.",
  "请填写百度网盘 Secret Key。": "Enter a Baidu Netdisk Secret Key.",
  "请填写百度网盘 Refresh Token。": "Enter a Baidu Netdisk Refresh Token.",
  "请填写 123 网盘 accessToken。": "Enter a 123Pan accessToken.",
  "请填写 123 网盘 clientID。": "Enter a 123Pan clientID.",
  "请填写 123 网盘 clientSecret。": "Enter a 123Pan clientSecret.",
  "存储目标「{p0}」需要填写{p1}。": 'Storage target "{p0}" requires {p1}.',
  "存储目标「{p0}」{p1}": 'Storage target "{p0}": {p1}',
  "云端为主模式需要选择一个原图位置。":
    "Cloud primary requires a location for originals.",
  "所选原图位置「{p0}」不存在。": 'Original location "{p0}" does not exist.',
  "所选位置不支持回读，无法作为原图位置。":
    "The selected location does not support readback and cannot hold originals.",
  "请至少选择一个归档目标。": "Select at least one archive target.",
  "系统通知权限未开启。": "System notification permission is disabled.",
  "浏览器通知权限未开启。": "Browser notification permission is disabled.",
  "当前环境不支持系统通知。":
    "System notifications are unavailable in this environment.",
  彩晶雾: "Crystal Mist",
  "Logo 晶面抽色,颗粒渐变流动":
    "Colors drawn from the logo, with flowing grain gradients",
  液态紫: "Liquid Violet",
  "默认液态玻璃,紫青粉渐变":
    "Liquid glass with violet, cyan, and pink gradients",
  等离子日落: "Plasma Sunset",
  "粉橙等离子脉冲,海报感":
    "Pink and orange plasma pulses with a poster-like feel",
  光束青: "Cyan Beams",
  "Beams 光束扫过,科技工程感": "Sweeping beams with a technical feel",
  网格灰: "Grid Gray",
  "静态点阵,纸感面板,省 GPU": "Static dots and paper panels with low GPU usage",
  字符矩阵: "Character Matrix",
  "终端数字雨,隐藏彩蛋": "Terminal character rain, a hidden theme",
  "操作失败，请稍后重试。": "Action failed. Try again later.",
  内容: "Content",
  没有可复制的内容: "No content to copy",
  "{p0}已复制到剪贴板。": "{p0} copied to the clipboard.",
  "没有可{p0}的图片": "No images available to {p0}",
  "{p0}{p1}失败": "{p0} {p1} failed",
  "没有可{p0}的任务": "No jobs available to {p0}",
  没有可打开的文件: "No files to open",
  打开失败: "Could not open",
  没有可显示的位置: "No location to reveal",
  打开文件夹失败: "Could not open folder",
  打开位置失败: "Could not open location",
};
